import { Directive, TemplateRef, EmbeddedViewRef, ViewContainerRef, Input, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserInfo } from '../../services/user-info';
import { UserInfoStore } from '../../services/user-info';

class Context {
  public hasPermissions = false;
}

@Directive({
  selector: '[pygPermissions]',
  standalone: false
})
export class PermissionsDirective {
  private readonly destroyRef = inject(DestroyRef);
  private infoStore = inject(UserInfoStore);
  private _context: Context = new Context();
  private _thenTemplateRef: TemplateRef<Context> | null = null;
  private _elseTemplateRef: TemplateRef<Context> | null = null;
  private _thenViewRef: EmbeddedViewRef<Context> | null = null;
  private _elseViewRef: EmbeddedViewRef<Context> | null = null;

  constructor(
    private _viewContainer: ViewContainerRef,
    templateRef: TemplateRef<Context>
  ) {
    this._thenTemplateRef = templateRef;
  }

  @Input()
  set pygPermissions(permissions: string[] | string) {
    this.infoStore.select$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(userInfo => {
        let hasPerms = false;

        if (Array.isArray(permissions)) {
          const perms = permissions.map(x => this.permissionsCheck(userInfo, x));
          hasPerms = perms.includes(true);
        } else {
          hasPerms = this.permissionsCheck(userInfo, permissions as string);
        }

        this._context.hasPermissions = hasPerms;
        this._updateView();
      });
  }

  @Input()
  set pygPermissionsThen(templateRef: TemplateRef<Context> | null) {
    this._thenTemplateRef = templateRef;
    this._thenViewRef = null; // clear previous view if any.
    this._updateView();
  }

  @Input()
  set pygPermissionsElse(templateRef: TemplateRef<Context> | null) {
    this._elseTemplateRef = templateRef;
    this._elseViewRef = null; // clear previous view if any.
    this._updateView();
  }

  private _updateView() {
    if (this._context.hasPermissions) {
      if (!this._thenViewRef) {
        this._viewContainer.clear();
        this._elseViewRef = null;
        if (this._thenTemplateRef) {
          this._thenViewRef = this._viewContainer.createEmbeddedView(this._thenTemplateRef, this._context);
        }
      }
    } else {
      if (!this._elseViewRef) {
        this._viewContainer.clear();
        this._thenViewRef = null;
        if (this._elseTemplateRef) {
          this._elseViewRef = this._viewContainer.createEmbeddedView(this._elseTemplateRef, this._context);
        }
      }
    }
  }

  private permissionsCheck(userInfo: UserInfo, permissions: string) {
    if (permissions === 'admin' && userInfo?.adminAccess === true) return true;
    // TODO: rozsirit o ostatne, ked bude treba

    return false;
  }
}
